import styles from './GetTheAppLink.module.scss';

import React from 'react';
import clsx from 'clsx';
import { useBowser } from 'hooks/useBowser/useBowser';
import { useToggle } from '@clover-util/use-toggle';
import { AppLink } from './AppLink/AppLink';
import { AppDownloadModal } from './AppDownloadModal';
import { CONFIRMATION_TEST_ID } from 'routes/Confirmation/const';
import { StringifiableRecord } from 'query-string';

type GetTheAppLinkProps = {
  className?: string;
  query?: StringifiableRecord;
};

export const GetTheAppLink: React.FC<GetTheAppLinkProps> = ({ className, query, children }) => {
  const bowser = useBowser();

  const [showDesktopAppModal, toggleDesktopAppModal] = useToggle(false);

  const isMobile = bowser.is('ios') || bowser.is('android');

  return (
    <>
      {isMobile && <AppLink className={className} query={query}>{children}</AppLink>}
      {!isMobile && <button className={clsx(styles.link, className)} onClick={toggleDesktopAppModal} data-testid={CONFIRMATION_TEST_ID.cmaHandoff}>{children}</button>}
      {showDesktopAppModal && <AppDownloadModal isOpen onClose={toggleDesktopAppModal} />}
    </>
  );
};

